// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___2aYUQ","close":"style__close___7rOf2","body":"style__body___2L3bZ","description":"style__description___3FEpU","descriptionHeader":"style__descriptionHeader___FyqJK","descriptionBody":"style__descriptionBody___1K3Hj","smallScreenText":"style__smallScreenText___2P5n6","applyNowButtonContainer":"style__applyNowButtonContainer___34hxK","applyNowButton":"style__applyNowButton___2KQ8F","imgContainer":"style__imgContainer___GNpJC","cardImg":"style__cardImg___1H6v8","cardImgFit":"style__cardImgFit___30eiz","smallText":"style__smallText___PJaQg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/banners/MySunbitBanner/style.scss
// module id = 1228
// module chunks = 0